import { css } from '@emotion/css';
import * as React from 'react';
import { FieldError } from 'react-hook-form';

import { Color } from 'css/theme';
import FormInputError from './FormInputError';

interface Props {
  children: React.ReactNode;
  name: string;
  error?: FieldError;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
}

const label = css({
  userSelect: 'none',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const checkbox = css({
  marginRight: '0.75rem',
  width: '1.125rem',
  height: '1.125rem',
  color: Color.DarkGray,
  marginTop: '0.125rem',
  borderColor: Color.BorderGray,
  ':disabled': {
    color: Color.LightGray,
  },
});

const FormCheckbox = ({ disabled = false, children, name, error, onClick }: Props, ref) => {
  return (
    <div>
      <label className={label}>
        <input
          disabled={disabled}
          className={`form-checkbox ${checkbox}`}
          id={name}
          ref={ref}
          name={name}
          type="checkbox"
          {...(onClick ? { onClick } : {})}
        />
        <div>{children}</div>
      </label>
      <FormInputError error={error?.message} />
    </div>
  );
};

export default React.forwardRef(FormCheckbox);
